import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
export interface ModalState {
  id: string | null;
  data?: any ;
}

export interface GlobalState {
  sidebarOpen: boolean;
  modalOpen: ModalState;
  permissions?: string[];
}

const initialModalOpen: ModalState = {
  id: null,
  data: null,
};

const initialState: GlobalState = {
  sidebarOpen: true,
  modalOpen: initialModalOpen,
  permissions: [],
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<ModalState | null>) => {
      state.modalOpen = action.payload || initialModalOpen;
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },
    clear: () => initialState,
  },
});

export default globalSlice.reducer;
export const { setPermissions, setModalOpen, setSidebarOpen, clear } =
  globalSlice.actions;
